import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
export default history;

//-----[Navigation Functions]-----

export const navTo = (path: string) => history.push(path);
